// Session de l'admin du chatbot. L'authentification elle-même est côté serveur (cookie de session
// Devise) : ce store ne fait que refléter qui est connecté, pour le routeur et l'interface.
import { defineStore } from 'pinia'
import apiClient, { setCSRFToken } from '../plugins/axios'

export const useAdminStore = defineStore('admin', {
  state: () => ({
    admin: null,
    checked: false,
  }),

  getters: {
    signedIn: (state) => !!state.admin,
  },

  actions: {
    apply(data) {
      this.admin = data.admin
      this.checked = true
      setCSRFToken(data.csrf_token)
    },

    // Une seule vérification par chargement de page : ensuite, c'est l'API qui renvoie 401 si la
    // session expire (voir plugins/axios.js).
    async ensureChecked() {
      if (this.checked) return
      const { data } = await apiClient.get('/admin/session')
      this.apply(data)
    },

    async login(email, password) {
      try {
        const { data } = await apiClient.post('/admin/session', { email, password })
        this.apply(data)
      } catch (error) {
        setCSRFToken(error.response?.data?.csrf_token)
        throw error
      }
    },

    async logout() {
      const { data } = await apiClient.delete('/admin/session')
      this.apply(data)
    },
  },
})
